import { useTranslation } from 'react-i18next';
import { AppLayout } from '@/components/layout/AppLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { CoachChat } from '@/components/coach/CoachChat';
import { LiveVitalsPanel } from '@/components/coach/LiveVitalsPanel';
import { useSyncTodayWorkout } from '@/hooks/useSyncTodayWorkout';

export default function Coach() {
  useSyncTodayWorkout();
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div className="h-[calc(100vh-7rem)] lg:h-[calc(100vh-4rem)] flex flex-col">
        <PageHeader
          title={t('nav.coach')}
          subtitle={t('coach.subtitle')}
          statusLabel={t('coach.statusLabel')}
          status="green"
        />
        <div className="flex-1 flex overflow-hidden">
          <CoachChat />
          {/* Desktop-only Live Vitals sidebar */}
          <div className="hidden lg:block">
            <LiveVitalsPanel />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
